const setMetaTag = (tagName, tagContent) => {
  let metaTag = document.querySelector(`meta[name=${tagName}]`);
  if (metaTag) {
    metaTag.setAttribute('content', tagContent);
  } else {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', tagName);
    metaTag.setAttribute('content', tagContent);
    document.querySelector('head').append(metaTag);
  }
  return metaTag;
};

setMetaTag('page_type', 'ppf');
